import { COLORS } from "../../../../constants";
export var chipSxProps = {
    "&.MuiChip-sizeSmall": {
        fontSize: "12px",
        lineHeight: "12px",
        letterSpacing: "0.4px",
        color: COLORS.P_MED_HIGH_EMPHASIS,
        height: "20px",
        borderRadius: "4px",
    },
    ".MuiChip-deleteIcon": {
        width: "12px",
        height: "12px",
        color: "".concat(COLORS.P_MED_HIGH_EMPHASIS, " !important"),
    },
    ".MuiChip-label": {
        overflow: "visible",
    },
};
